import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { MijnOrganisatieListItem } from '../../models/user/mijnOrganisatieListItem';
import ImportGeoPackage from '../../components/controls/ImportGeoPackage';
import { userManagementService } from '../../services/user-management.service';
import NoActiveOrganisatieMessage from '../../components/controls/NoActiveOrganisatieMessage';
import { Paper } from '@mui/material';
import { GeoPackageType } from '../../models/types/geoPackageType';

const PagePlannenImport: React.FC = () => {
  const [mijnOrganisatie, setMijnOrganisatie] = useState<MijnOrganisatieListItem | null>(null);

  useEffect(() => {
    const storedOrganisatie = userManagementService.getStoredOrganisatie();
    if (storedOrganisatie) {
      setMijnOrganisatie(storedOrganisatie);
    }
  }, []); // Empty dependency array ensures this runs once when the component mounts

  return (
    <>
      <header className="page-header container">
        <h1>Plannen importeren</h1>
        <p className="header-sub-title">
          Het is mogelijk om plannen uit uw eigen GIS systeem te exporteren in GeoPackage formaat (.gpkg) en te importeren in infraplannen.nl. 
          Het bestand met de plannen moet voldoen aan de <a href="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/628326403/Technische+specificatie+infraplannen.nl" target="_blank" rel="noopener noreferrer">vereisten</a>.
        </p>
      </header>

      <section>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p>
                Als u een bestand uploadt, dan wordt het bestand weer gecontroleerd. 
                Daarna ziet u een resultaat van de controle in een overzicht van nieuwe, gewijzigde en verwijderde plannen en kunt u besluiten het gecontroleerde Geopackage bestand te laten verwerken.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <div className="content">

        {mijnOrganisatie && mijnOrganisatie.id ? (
          <>
            <ImportGeoPackage type={GeoPackageType.PLAN} organisatieId={mijnOrganisatie.id} />
          </>
        ) : (
          <Paper>
            <NoActiveOrganisatieMessage />
          </Paper>
        )}

      </div>
      
      <Outlet /> 
    </>
  );
};

export default PagePlannenImport;